import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export const constantRoutes = [
  {
    path: '/',
    redirect: '/login'
  },

  {
    path: '/login',
    component: () => import('@/components/login/index'),
    hidden: true
  },

  {
    path: '/form',
    name: 'home',
    component: () => import('@/views/index/Home')
  },
  {
    path: '/role',
    component: Layout,
    meta: { title: '角色管理', icon: 'dashboard' },
    children: [
      {
        path: 'edit',
        ishidden: true,
        component: () => import('@/views/roleManagement/roles/edit'),
        meta: { title: '', icon: 'dashboard', activeMenu: '/role/index' }
      }
    ]
  },
  {
    path: '/studentManagement',
    component: Layout,
    meta: { title: '学生管理', icon: 'dashboard' },
    children: [
      {
        path: '/studentManagement/studentDetails',
        ishidden: true,
        component: () => import('@/views/studentManagement/studentDetails.vue'),
        meta: { title: '学生详情', icon: 'dashboard', activeMenu: '/studentManagement/studentList' }
      },
      {
        path: '/studentManagement/studentListSZDetails',
        ishidden: true,
        component: () => import('@/views/studentManagement/studentListSZDetails.vue'),
        meta: { title: '学生详情', icon: 'dashboard', activeMenu: '/studentManagement/studentList' }
      },
      {
        path: '/studentManagement/gradeTextbookDetail',
        component: () => import('@/views/studentManagement/gradeTextbookDetail.vue'),
        meta: { title: '学生归档练习详情', icon: 'dashboard', activeMenu: '/studentManagement/endGradeTextbook' }
      },
      {
        path: '/studentManagement/examDetail',
        component: () => import('@/views/studentManagement/examDetail.vue'),
        meta: { title: '学生归档考试详情', icon: 'dashboard', activeMenu: '/studentManagement/endVExam' }
      }
    ]
  },
  {
    path: '/questionManage',
    component: Layout,
    meta: { title: '题库管理', icon: 'dashboard' },
    children: [
      {
        path: '/modulesManage/index',
        ishidden: true,
        component: () => import('@/views/questionManagement/modules/index.vue'),
        meta: { title: '录入题目', icon: 'dashboard', activeMenu: '/questionManage/index' }
      },
      {
        path: '/reModulesManage/index',
        ishidden: true,
        component: () => import('@/views/resistEpidemicManagement/modules/index.vue'),
        meta: { title: '录入抗疫题目', icon: 'dashboard', activeMenu: '/resistEpidemicManage/index' }
      },
      // {
      //   path: '/resistEpidemicManage/index',
      //   ishidden: true,
      //   component: () => import('@/views/resistEpidemicManagement/resistEpidemicManage/index.vue'),
      //   meta: { title: '抗疫题库', icon: 'dashboard' }
      // },
      {
        path: '/collectModulesManage/index',
        ishidden: true,
        component: () => import('@/views/questionManagement/modules/index.vue'),
        meta: { title: '录入收藏题目', icon: 'dashboard', activeMenu: '/questionCollectManage/index' }
      },
      {
        path: '/goodModulesManage/index',
        ishidden: true,
        component: () => import('@/views/questionManagement/modules/index.vue'),
        meta: { title: '录入精品题目', icon: 'dashboard', activeMenu: '/questionBoutiqueManage/index' }
      },
      {
        path: '/translateManage/index',
        ishidden: true,
        component: () => import('@/views/addManage/addInterQuestion.vue'),
        meta: { title: '国际题库', icon: 'dashboard', activeMenu: '/questionTranslateManage/index' }
      }
    ]
  },
  {
    path: '/questionRestraManage',
    component: Layout,
    meta: { title: '题库管理', icon: 'dashboard' },
    children: [
      {
        path: '/theoryQuestionManagement/index',
        ishidden: true,
        component: () => import('@/views/questionManagement/questionRestraManage/modules/index.vue'),
        meta: { title: '录入题目', icon: 'dashboard', activeMenu: '/questionRestraManage/index' }
      }
    ]
  },
  {
    path: '/systems',
    component: Layout,
    meta: { title: '系统设置', icon: 'dashboard' },
    children: [
      {
        path: '/contestManagement/create',
        ishidden: true,
        component: () => import('@/views/systems/components/createContest.vue'),
        meta: { title: '比赛报名管理', icon: 'dashboard', activeMenu: '/contestManagement' }
      }
    ]
  },
  {
    path: '/textbooks',
    alias: '/',
    component: Layout,
    meta: { title: '考试管理', icon: 'dashboard' },
    children: [
      {
        path: '/textPaper/testPaper',
        ishidden: true,
        component: () => import('@/views/textPaper/testPaper.vue'),
        meta: { title: '新增考卷', icon: 'dashboard', activeMenu: '/teachManagement' }
      },
      {
        path: '/textbooks/weaveTextBook',
        ishidden: true,
        component: () => import('@/views/textbooks/weaveTextBook.vue'),
        meta: { title: '新增教材', icon: 'dashboard', activeMenu: '/management' }
      }
    ]
  },
  {
    path: '/competitionManage',
    alias: '/',
    component: Layout,
    meta: { title: '比赛管理', icon: 'dashboard' },
    children: [
      {
        path: '/testPaperManage/releaseCompetition',
        ishidden: true,
        component: () => import('@/views/competitionManage/testPaperManage/releaseCompetition.vue'),
        meta: { title: '发布比赛', icon: 'dashboard', activeMenu: '/competitionManage/testPaperManage' }
      },
      {
        path: '/contestManagement/release',
        ishidden: true,
        component: () => import('@/views/competitionManage/gameManage/release.vue'),
        meta: { title: '发布比赛', icon: 'dashboard', activeMenu: '/competitionManage/gameManage' }
      },
      // 比赛创建试卷/录入题目 创建单独路由
      {
        path: '/testPaperManage/createPaper',
        ishidden: true,
        component: () => import('@/views/textPaper/testPaper.vue'),
        meta: { title: '创建竞赛试卷', icon: 'dashboard', activeMenu: '/competitionManage/testPaperManage' }
      },
      // {
      //   path: '/competitionManage/entryQuestion',
      //   ishidden: true,
      //   component: () => import('@/views/questionManagement/modules/index.vue'),
      //   meta: { title: '录入竞赛题目', icon: 'dashboard', activeMenu: '/competitionManage/scoreManage' }
      // },
      {
        path: '/contestManagement/createthings',
        ishidden: true,
        component: () => import('@/views/competitionManage/gameManage/addThings.vue'),
        meta: { title: '赛事管理', icon: 'dashboard', activeMenu: '/competitionManage/gameManage' }
      },
      {
        path: '/competitionManage/modulesManage/index',
        ishidden: true,
        component: () => import('@/views/competitionManage/scoreManage/modules/index.vue'),
        meta: { title: '题目管理', icon: 'dashboard', activeMenu: '/competitionManage/scoreManage' }
      },
      {
        path: '/competitionManage/createTextPaper',
        ishidden: true,
        component: () => import('@/views/competitionManage/testPaperManage/createTextPaper.vue'),
        meta: { title: '试题管理', icon: 'dashboard', activeMenu: '/competitionManage/testPaperManage' }
      }
    ]
  },
  {
    path: '/rotationManage',
    alias: '/',
    component: Layout,
    meta: { title: '轮转管理', icon: 'dashboard' },
    children: [
      {
        path: '/rotationManage/createBook',
        ishidden: true,
        component: () => import('@/views/textbooks/weaveTextBook.vue'),
        meta: { title: '轮转教材', icon: 'dashboard', activeMenu: '/rotationManage/rotatingTextbooks' }
      },
      {
        path: '/rotationManage/lookLibraryBook',
        ishidden: true,
        component: () => import('@/views/rotationManage/rotatingTextbooks/lookLibraryBook.vue'),
        meta: { title: '查看教材', icon: 'dashboard', activeMenu: '/rotationManage/rotatingTextbooks' }
      },
      {
        path: '/rotationManage/createPaper',
        ishidden: true,
        component: () => import('@/views/textPaper/testPaper.vue'),
        meta: { title: '轮转考卷', icon: 'dashboard', activeMenu: '/rotationManage/rotatingPaper' }
      },
      {
        path: '/rotationManage/studentDetails',
        ishidden: true,
        component: () => import('@/views/studentManagement/studentDetails.vue'),
        meta: { title: '轮转学员', icon: 'dashboard', activeMenu: '/rotationManage/orgManage' }
      }
    ]
  },
  {
    path: '/websiteManagement',
    alias: '/',
    component: Layout,
    meta: { title: '官网管理', icon: 'dashboard' },
    children: [
      {
        path: '/websiteManagement/createTeachBase',
        ishidden: true,
        component: () => import('@/views/websiteManagement/coreTeam/createTeachBase.vue'),
        meta: { title: '新建教学基地', icon: 'dashboard', activeMenu: '/websiteManagement/coreTeam' }
      },
      {
        path: '/websiteManagement/addPeople',
        ishidden: true,
        component: () => import('@/views/websiteManagement/coreTeam/addPeople.vue'),
        meta: { title: '新建教学基地-添加人员', icon: 'dashboard', activeMenu: '/websiteManagement/coreTeam' }
      },
      {
        path: '/websiteManagement/createTeachCase',
        ishidden: true,
        component: () => import('@/views/websiteManagement/processTeach/createCase.vue'),
        meta: { title: '过程化教学案例', icon: 'dashboard', activeMenu: '/websiteManagement/processTeach' }
      },
      {
        path: '/websiteManagement/createBigEvents',
        ishidden: true,
        component: () => import('@/views/websiteManagement/processTeach/createCase.vue'),
        meta: { title: '大型赛事案例', icon: 'dashboard', activeMenu: '/websiteManagement/bigEvents' }
      },
      {
        path: '/websiteManagement/createSubject',
        ishidden: true,
        component: () => import('@/views/websiteManagement/projectManagement/createSubject.vue'),
        meta: { title: '新建课题', icon: 'dashboard', activeMenu: '/websiteManagement/projectManagement' }
      },
      {
        path: '/websiteManagement/createThesis',
        ishidden: true,
        component: () => import('@/views/websiteManagement/thesisManagement/createThesis.vue'),
        meta: { title: '新建论文', icon: 'dashboard', activeMenu: '/websiteManagement/thesisManagement' }
      }
    ]
  },
  {
    path: '/addManage',
    alias: '/',
    component: Layout,
    meta: { title: '录题管理', icon: 'dashboard' },
    children: [
      {
        path: '/addManage/addInterQuestion',
        ishidden: true,
        component: () => import('@/views/addManage/addInterQuestion.vue'),
        meta: { title: 'spark国际题库', icon: 'dashboard', activeMenu: '/addManage/interManage/index' }
      },
      {
        path: '/addManage/modulesManage',
        ishidden: true,
        component: () => import('@/views/questionManagement/modules/index.vue'),
        meta: { title: '星火题库', icon: 'dashboard', activeMenu: '/addManage/index' }
      },
      {
        path: '/addManage/theoryQuestionManagement',
        ishidden: true,
        component: () => import('@/views/questionManagement/questionRestraManage/modules/index.vue'),
        meta: { title: '住培题库', icon: 'dashboard', activeMenu: '/addManage/questionRestraManage/index' }
      }
    ]
  },
  {
    path: '/virtualLab',
    alias: '/',
    component: Layout,
    meta: { title: '虚拟实验室', icon: 'dashboard' },
    children: [
      {
        path: '/virtualLab/editReport',
        ishidden: true,
        component: () => import('@/views/virtualLab/editReport.vue'),
        meta: { title: '虚拟报告库', icon: 'dashboard', activeMenu: '/getStockRptList' }
      },
      {
        path: '/virtualLab/myeditReport',
        ishidden: true,
        component: () => import('@/views/virtualLab/editReport.vue'),
        meta: { title: '我的题库', icon: 'dashboard', activeMenu: '/virtualLab/MyQuestionList' }
      },
      {
        path: '/virtualLab/practice',
        ishidden: true,
        component: () => import('@/views/virtualLab/practice.vue'),
        meta: { title: '练习一览', icon: 'dashboard', activeMenu: '/textbook/index' }
      },
      {
        path: '/virtualLab/practiceDetail',
        ishidden: true,
        component: () => import('@/views/virtualLab/practiceDetail.vue'),
        meta: { title: '练习详情', icon: 'dashboard', activeMenu: '/textbook/index' }
      }
    ]
  },
  {
    path: '/teacherManage',
    ishidden: true,
    component: Layout,
    meta: { title: '老师一览', icon: 'lsgl' },
    children: [
      {
        path: '/teacherManage/teacherDetails',
        ishidden: true,
        component: () => import('@/views/teacherManage/teacherDetails.vue'),
        meta: { title: '老师详情', icon: 'lsgl', activeMenu: '/teacherManage/index' }
      },
      {
        path: 'edit',
        ishidden: true,
        component: () => import('@/views/roleManagement/roles/edit'),
        meta: { title: '', icon: 'dashboard', activeMenu: '/teacherManage/index' }
      }
    ]
  },
  {
    path: '/eduCenter',
    component: Layout,
    meta: { title: '我的班级', icon: 'dashboard' },
    children: [
      {
        path: '/eduCenter/edit',
        ishidden: true,
        component: () => import('@/views/roleManagement/roles/edit'),
        meta: { title: '新增用户', icon: 'dashboard', activeMenu: '/eduCenter/index' }
      },
      {
        path: '/eduCenter/studetail',
        ishidden: true,
        component: () => import('@/views/eduCenter/studetail.vue'),
        meta: { title: '学生详情', icon: 'dashboard', activeMenu: '/eduCenter/index' }
      },
      {
        path: '/eduCenter/gradedetail',
        ishidden: true,
        component: () => import('@/views/eduCenter/gradedetail.vue'),
        meta: { title: '班级详情', icon: 'dashboard', activeMenu: '/eduCenter/index' }
      },
      {
        path: '/eduCenter/studentListSZDetails',
        ishidden: true,
        component: () => import('@/views/studentManagement/studentListSZDetails.vue'),
        meta: { title: '学生详情', icon: 'dashboard', activeMenu: '/eduCenter/index' }
      },
      {
        path: '/eduCenter/readStudentList',
        ishidden: true,
        component: () => import('@/views/eduCenter/amendStudentList.vue'),
        meta: { title: '批阅学生列表', icon: 'dashboard', activeMenu: '/eduCenter/amend/index' }
      },
      {
        path: '/eduCenter/reading',
        ishidden: true,
        component: () => import('@/views/eduCenter/amending.vue'),
        meta: { title: '批阅学生列表', icon: 'dashboard', activeMenu: '/eduCenter/amend/index' }
      }
    ]
  },
  {
    path: '/dataScreen',
    name: 'dataScreen',
    component: () => import('@/views/dataScreen/index')
  },
  {
    path: '/dataScreenLine',
    name: 'dataScreenLine',
    component: () => import('@/views/dataScreen/indexLine')
  }
]

const createRouter = () => new Router({
  mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js